<template>
  <b-modal
    centered
    scrollable
    size="xl"
    v-if="show"
    v-model="show"
    title="图片设置"
  >
    <div>
      <div :align="data.align" style="margin-bottom: 20px;">
        <img :src="data.imgUrl" :width="data.width" :height="data.height" :alt="data.alt" />
      </div>
      <b-container fluid>
        <b-row class="my-1" v-for="(option, index) in options" :key="index">
          <b-col sm="2">
            <label>{{ option.text }}</label>
          </b-col>
          <b-col sm="10">
            <b-form-input v-if="option.tag === 'input'" :type="option.type" v-model="data[option.field]" />
            <b-form-select v-else-if="option.tag === 'select'" v-model="data[option.field]" :options="selectOptions[option.field]" />
          </b-col>
        </b-row>
      </b-container>
    </div>
    <template #modal-footer>
      <b-button
        variant="secondary"
        @click="cancel"
      >
        取消
      </b-button>
      <b-button
        variant="primary"
        @click="ok"
      >
        确定
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'image-conf',
  props: ['showData'],
  data () {
    return {
      show: false,
      data: null,
      options: [
        { text: '位置', field: 'align', tag: 'select', value: 'left' },
        { text: '宽度', field: 'width', tag: 'input', type: 'text', value: '500' },
        { text: '高度', field: 'height', tag: 'input', type: 'text', value: '300' },
        { text: '图片名称', field: 'alt', tag: 'input', type: 'text', value: '' }
      ],
      selectOptions: {
        align: [
          { text: '靠左', value: 'left' },
          { text: '居中', value: 'center' },
          { text: '靠右', value: 'right' }
        ]
      }
    }
  },
  watch: {
    showData (val) {
      this.data = val
    }
  },
  methods: {
    modalShow () {
      this.show = true
    },
    ok () {
      this.$emit('returnConf', this.data)
      this.show = false
    },
    cancel () {
      this.show = false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ImageConf.vue?7b13ee0f